import { render, staticRenderFns } from "./forum_list.vue?vue&type=template&id=765920e3&scoped=true"
import script from "./forum_list.vue?vue&type=script&lang=js"
export * from "./forum_list.vue?vue&type=script&lang=js"
import style0 from "./forum_list.vue?vue&type=style&index=0&id=765920e3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765920e3",
  null
  
)

export default component.exports